import useHotkey from '../hooks/use-hotkey';
import { setHotkey } from '@form-engine/builder-application/keybindings';
import { useFormContext } from '@form-engine/core-application/hooks/use-form';
import { useCallback } from 'react';
import { FormDefinition } from '@form-engine/core-application/types/form';
import FormEngine from '@form-engine/core-application';
import saveFile from '@form-engine/builder-application/utilities/save-file';

function exportFormAsXfe(
    source: FormDefinition,
    filename = 'export.xfe',
    type = 'application/x-xfe'
) {
    saveFile(JSON.stringify(source, undefined, 2), filename, type);
}

export default function useExportFormAction() {
    const { state } = useFormContext();
    return useCallback(async () => {
        exportFormAsXfe(
            { ...state, engineVersion: FormEngine.version },
            `${state.name || 'untitled'}.xfe`
        );
    }, [state]);
}

export const ACTION_NAME = 'formEditor.form.export';

setHotkey(ACTION_NAME, 'ctrl+alt+e,meta+alt+e');

export const useAction = useExportFormAction;

export function useActionHotkey() {
    useHotkey(ACTION_NAME, useAction());
}
